import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OAccordion as OAccordionComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OAccordionConfig = {
  emptyLabel: 'OAccordion',
  isEmpty: () => true,
  resourceType: 'mi-aem-utils/components/content/o-accordion',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OAccordion = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div data-testid="o-accordion-comp" data-component-name="o-accordion" id={componentId} className={clsx(styleclass)}>
      <EditableComponent config={OAccordionConfig} {...props}>
        <OAccordionComp {...props} />
      </EditableComponent>
    </div>
  );
};
